import { ExcpRole, ExcpRoleSearchParam } from 'models/admin/ExcpRole';
import { Employee } from 'models/admin/Employee';
import { CommonRequest, Method, ServiceName, CommonResponse } from 'models/common/RestApi';
import { callApi } from 'utils/ApiUtil';

export const getExcpReqList = async (condition: ExcpRoleSearchParam) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/excp/authReqList`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<ExcpRole[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as ExcpRole[];
};

export const getExcpRoleist = async () => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/excp/roleList`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<ExcpRole[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as ExcpRole[];
};

export const getExcpPrjList = async (excpId: string) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/excp/prjListByExcpId/${excpId}`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<ExcpRole[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as ExcpRole[];
};

export const getExcpRequestList = async (aprReqId: string): Promise<ExcpRole | null> => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/excp/request/${aprReqId}`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<ExcpRole> = await callApi(request);
  if (response.successOrNot !== 'Y' || !response.data) return null;
  return response.data;
};

export const getExcpAuthGrantorList = async (condition: any) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/excp/authGrantorList`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: condition,
  };
  const response: CommonResponse<Employee[]> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : null) as Employee[];
};
